export function replaceNewlinesForLoad( data ) {
	if ( ! data ) return data;

	if ( Array.isArray( data ) ) {
		return data.map( item => replaceNewlinesForLoad( item ) );
	}

	if ( typeof data === 'object' && data !== null ) {
		const result = { ...data };
		if ( result.text && typeof result.text === 'string' ) {
			result.text = result.text.replace( /\{n\}/g, '\n' ).replace( /\/n/g, '\n' );
		}
		if ( result.layers && Array.isArray( result.layers ) ) {
			result.layers = result.layers.map( layer => replaceNewlinesForLoad( layer ) );
		}
		return result;
	}

	return data;
}

export function blockDefaultContextMenu() {
	const builderContainer = document.querySelector('.lp-certificate-edit-builder');
	if (builderContainer) {
		builderContainer.addEventListener('contextmenu', (e) => {
			e.preventDefault();
			return false;
		});
	}
}

export function convertTitlesToTooltips() {
	const container = document.querySelector( '.lp-certificate-edit-wrapper' );
	if ( ! container ) return;

	container.querySelectorAll( '[title]' ).forEach( ( el ) => {
		const title = el.getAttribute( 'title' );
		if ( title ) {
			el.setAttribute( 'data-tooltip', title );
			el.removeAttribute( 'title' );
		}
	} );
}

export function generateLayerId( index = null ) {
	const timestamp = Date.now();
	const random = Math.random().toString( 36 ).substr( 2, 9 );
	if ( index !== null ) {
		return `layer_${ timestamp }_${ index }_${ random }`;
	}
	return `layer_${ timestamp }_${ random }`;
}

export function autoResizeCanvasToFit( canvas ) {
	if ( ! canvas ) {
		return null;
	}

	const canvasWrapper = canvas.wrapperEl;
	const container = canvasWrapper?.parentElement;

	if ( ! canvasWrapper || ! container ) {
		return null;
	}

	container.style.position = 'relative';
	container.style.overflow = 'hidden';

	const containerWidth = container.clientWidth;
	const containerHeight = container.clientHeight;

	if ( containerWidth < 100 || containerHeight < 100 ) {
		return () => autoResizeCanvasToFit( canvas );
	}

	const canvasWidth = canvas.getWidth();
	const canvasHeight = canvas.getHeight();

	const scaleX = containerWidth / canvasWidth;
	const scaleY = containerHeight / canvasHeight;
	const scale = Math.min( scaleX, scaleY, 1 );

	if ( scale < 1 ) {
		canvasWrapper.style.transform = `scale(${ scale })`;
		canvasWrapper.style.transformOrigin = 'top center';
	} else {
		canvasWrapper.style.transform = '';
	}

	return null;
}

export async function loadGoogleFontDynamic( fontFamily ) {
	const existingStyleTag = document.getElementById( 'lp-certificates-fonts-gg' );
	if ( existingStyleTag && existingStyleTag.textContent.includes( fontFamily ) ) {
		return;
	}

	const linkId = `google-font-${ fontFamily.replace( /\s+/g, '-' ).toLowerCase() }`;
	if ( document.getElementById( linkId ) ) {
		return;
	}

	const link = document.createElement( 'link' );
	link.id = linkId;
	link.rel = 'stylesheet';
	link.href = `https://fonts.googleapis.com/css2?family=${ encodeURIComponent( fontFamily ) }&display=swap`;
	document.head.appendChild( link );

	return new Promise( ( resolve ) => {
		link.onload = () => {
			setTimeout( resolve, 100 );
		};
		link.onerror = () => {
			console.warn( `Failed to load Google Font: ${ fontFamily }` );
			resolve();
		};
	} );
}

